import { useCallback, useRef } from 'react'
import { RecoilState, SetterOrUpdater, useRecoilState } from 'recoil'

type GetStateAction<S> = () => S
function useGetRecoilState<S>(recoilState: RecoilState<S>): [S, SetterOrUpdater<S>, GetStateAction<S>] {
  const [state, setState] = useRecoilState(recoilState)
  const stateRef = useRef(state)
  stateRef.current = state

  const getState = useCallback(() => stateRef.current, [])

  return [state, setState, getState]
}

export default useGetRecoilState
